import { useEffect, useState } from "react";
import { useStripe } from "@stripe/react-stripe-js";
import { useNavigate } from "react-router-dom";
import successIcon from '../assets/pic/check1.png';
import errorIcon from '../assets/pic/close.png';
import { Text } from "../languages/Language";

const PaymentSuccess = ({ onSuccess }) => {
  const stripe = useStripe();
  const [message, setMessage] = useState("Payment is checking...");
  const [errorDetail, setErrorDetail] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    const clientSecret = query.get("payment_intent_client_secret");

    if (!clientSecret || !stripe) return;

    stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent, error }) => {
      if (error) {
        setMessage("An error occured.");
        setErrorDetail(error.message);
        return;
      }

      switch (paymentIntent.status) {
        case "succeeded":
          sessionStorage.setItem('paymentTrackingId', paymentIntent.id);
          setMessage("Paymennt successfully completed, redirecting to home page...");
          onSuccess?.();
          setTimeout(() => navigate("/"), 1000);
          break;
        case "processing":
          setMessage("Payment is being processed, please wait...");
          break;
        case "requires_payment_method":
          setMessage("Payment failed, please try again.");
          break;
        default:
          setMessage("Unknown payment status.");
          break;
      }
    });
  }, [stripe]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen text-center px-4">
        {message.includes("successfully") && (
        <img src={successIcon} alt="Success" className="w-16 h-16 mb-4" />
      )}
        {message.includes("failed") && (
        <img src={errorIcon} alt="Failed" className="w-16 h-16 mb-4" />
      )}
      <div className="mb-4 animate-pulse text-lg font-semibold text-gray-700">{message}</div>
      {errorDetail && <div className="text-sm text-red-500">{errorDetail}</div>}
      {message.includes("failed") && (
        <button
          onClick={() => navigate("/")}
          className="mt-6 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
        >
          <Text tid="TurnHomePage" />
        </button>
      )}
    </div>
  );
};

export default PaymentSuccess;
